// extracted by css-extract-rspack-plugin
export default {"titleSkeletonRow":"T07mF6","skeleton":"J3OVqX","dividerHalf":"nZLN4s","trigger":"yv9v6Y","title":"nTHerZ","menuIcon":"QFPA5k","menuContent":"qsuPl7","removeIcon":"XX3RLe"};